import * as yup from "yup";
import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";

export const ConfiguracaoBuscaExternaSchema = yup.object({
  loginPrefeitura: yup
    .string()
    .nullable()
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .test({
      name: "loginPrefeitura",
      message: "O campo usuário não pode ser vazio!",
      test: function (value) {
        const { senhaPrefeitura } = this.parent;
        if (!value && senhaPrefeitura) {
          return false;
        }
        return true;
      },
    }),
  senhaPrefeitura: yup
    .string()
    .nullable()
    .test({
      name: "senhaPrefeitura",
      message: "O campo senha não pode ser vazio!",
      test: function (value) {
        const { loginPrefeitura } = this.parent;
        if (!value && loginPrefeitura) {
          return false;
        }
        return true;
      },
    }),
  certificadoDigitalBase64: yup
    .string()
    .nullable()
    .test({
      name: "certificadoDigitalBase64",
      message: "O campo certificado não pode ser vazio!",
      test: function (value) {
        const { senhaCertificadoDigital } = this.parent;
        if (!value && senhaCertificadoDigital) {
          return false;
        }
        return true;
      },
    }),
  senhaCertificadoDigital: yup
    .string()
    .nullable()
    .test({
      name: "senhaCertificadoDigital",
      message: "O campo senha do certificado não pode ser vazio!",
      test: function (value) {
        const { certificadoDigitalBase64 } = this.parent;
        if (!value && certificadoDigitalBase64) {
          return false;
        }
        return true;
      },
    }),
});